<template>
  <path pid="0" d="M18.18 16.76a8.49 8.49 0 10-1.42 1.42l4.53 4.53a1 1 0 001.42-1.42zm-2-.71h-.05v.05a6.5 6.5 0 11.09-.09z"/>
</template>
